import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import DucumentManagementWidget from '../../../widgets/auditWidgets/ducumentManagementWidgets/DucumentManagementWidget'
import {
  getDocumentManageIa,
  getEmailAttchMange,
} from '../../../redux/actions/IaDucumentManagement'
import EmailAttManagementWidget from '../../../widgets/auditWidgets/ducumentManagementWidgets/EmailAttManagementWidget'
import LinkedAttManagementWidget from '../../../widgets/auditWidgets/ducumentManagementWidgets/LinkedAttManagementWidget'

export default function EmailAttManagement() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectId = sessionStorage.getItem('projectId')
  const auditInfo = sessionGetItemObj('auditInfo')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    // setSchema(mockSchema.model)
    setIsLoading(true)
    startLoading()
    try {
      const response = await getEmailAttchMange()
      console.log('resssss => ', response)

      if (response) {
        setSchema(response)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // console.log('schema => ', schema)

  if (error) {
    return (
      <SidebarProposal isAudit>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAudit>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAudit>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <EmailAttManagementWidget
          schema={schema.emailAttachedForm}
          // schemaLinked={schema.linkedInContentForm}
        />

        <LinkedAttManagementWidget schema={schema.linkedInContentForm} />

        <br />
      </SidebarProposal>
    </div>
  )
}
